import baseApi from '../../lib/baseApi';


// Fellowship Relationship APIs --------------------------------------------------------------------

// Expecting paginated response: { results: [...], count: ..., next: ..., previous: ... }
export const searchFellowshipApi = async (query: string, page: number = 1) => {
  const response = await baseApi.get(`/profiles/fellowship/search-friends/?q=${query}&page=${page}`);
  return response.data; // Keep full paginated object
};


// Fetch sent fellowship requests
export const fetchFellowshipSentRequestsApi = async () => {
  const response = await baseApi.get('/profiles/fellowship/sent-requests/');
  return response.data;
};

// Fetch received fellowship requests
export const fetchFellowshipReceivedRequestsApi = async () => {
  const response = await baseApi.get('/profiles/fellowship/received-requests/');
  return response.data;
};

// Fetch list of fellowships
export const fetchFellowshipListApi = async () => {
  const response = await baseApi.get('/profiles/fellowship/fellowship-list/');
  return response.data;
};

// Send a fellowship request
export const sendFellowshipRequestApi = async (toUserId: number, fellowshipType: string, reciprocalFellowshipType: string | null) => {
  const response = await baseApi.post('/profiles/fellowship/', {
    to_user_id: toUserId,
    fellowship_type: fellowshipType,
    reciprocal_fellowship_type: reciprocalFellowshipType,
  });
  return response.data;
};



// Accept a fellowship request
export const acceptFellowshipRequestApi = async (fellowshipId: number, reciprocalFellowshipType: string | null) => {
  const response = await baseApi.post(`/profiles/fellowship/${fellowshipId}/accept-request/`, {
    reciprocalFellowshipType,
  });
  return response.data;
};



// Decline a fellowship request
export const declineFellowshipRequestApi = async (fellowshipId: number, reciprocalFellowshipType: string | null) => {
  const response = await baseApi.post(`/profiles/fellowship/${fellowshipId}/decline-request/`, { reciprocalFellowshipType });
  return response.data;
};


// Cancel a fellowship request
export const cancelFellowshipRequestApi = async (fellowshipId: number) => {
  const response = await baseApi.post(`/profiles/fellowship/${fellowshipId}/cancel-request/`);
  return response.data;
};



// Delete a fellowship
export const deleteFellowshipApi = async ({ fellowshipId, relationshipType, }: { fellowshipId: number; relationshipType: string; }) => {
  const response = await baseApi.post('/profiles/fellowship/delete-fellowship/', {
    fellowshipId,
    relationshipType,
  });
  return response.data;
};
